// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"9f12ab0b","20":"a78d2c2b","31":"72b5252b","587":"29355825","768":"a22aaa4c","808":"ab748a48"}[chunkId] + ".chunk.css";
};